const getNextAvailableTitle = (title, data = [], dataKey = "name") => {
  if (!data.length || !data.find((d) => d[dataKey] === title)) {
    return title;
  }

  const escaped = title.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`^${escaped} \\((\\d*)\\)$`);
  const matches = data.filter((d) => d[dataKey]?.match(regex));

  if (matches.length === 0) {
    return `${title} (1)`;
  }

  const highest = matches.sort()[matches.length - 1];
  const prevNumber = Number(highest[dataKey].match(/(\d+)/)[0]);
  return `${title} (${prevNumber + 1})`;
};

export default getNextAvailableTitle;
